export type Currency = {
  id: string;
  code: string;
  name_en?: string;
  name_ar?: string;
  symbol?: string;
  icon?: string | null;
  exchange_rate?: string;
  is_base?: boolean;
  decimal_places?: number;
};

export const CURRENCY_STORAGE_KEY = "uno_currency";
export const CURRENCY_COOKIE_KEY = "uno_currency";

export function readStoredCurrency(): Currency | null {
  try {
    const raw = window.localStorage.getItem(CURRENCY_STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as Currency;
  } catch {
    return null;
  }
}

export function writeStoredCurrency(currency: Currency) {
  try {
    window.localStorage.setItem(CURRENCY_STORAGE_KEY, JSON.stringify(currency));
  } catch {
    return;
  }
}

export function writeCurrencyCookie(currency: Currency) {
  try {
    const value = encodeURIComponent(JSON.stringify(currency));
    document.cookie = `${CURRENCY_COOKIE_KEY}=${value}; path=/; max-age=31536000`;
  } catch {
    return;
  }
}

export function readCurrencyCookieClient(): Currency | null {
  try {
    const parts = document.cookie.split(";").map((p) => p.trim());
    const hit = parts.find((p) => p.startsWith(`${CURRENCY_COOKIE_KEY}=`));
    if (!hit) return null;
    const raw = decodeURIComponent(hit.slice(CURRENCY_COOKIE_KEY.length + 1));
    return JSON.parse(raw) as Currency;
  } catch {
    return null;
  }
}

export function currencyHeaderValue(
  currency: Currency | null | undefined
): string | undefined {
  const code = currency?.code;
  if (!code || typeof code !== "string") return undefined;
  return code.toUpperCase();
}
